var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "basic-form-container" }, [
    _c(
      "div",
      { staticClass: "left-section" },
      [
        _c(
          "el-form-item",
          { attrs: { label: "是否可预定" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.canBook,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "canBook", $$v)
                  },
                  expression: "formData.canBook",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("不可预定")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("可预定")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.formData.canBook === 1
          ? _c(
              "el-form-item",
              { attrs: { label: "预定时间" } },
              [
                _c("el-time-picker", {
                  attrs: {
                    placeholder: "请选择时间",
                    format: "HH:mm",
                    "value-format": "HH:mm",
                  },
                  model: {
                    value: _vm.formData.preTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "preTime", $$v)
                    },
                    expression: "formData.preTime",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "自提推送" } },
          [
            _c("el-switch", {
              model: {
                value: _vm.pushSetting.selfPickup,
                callback: function ($$v) {
                  _vm.$set(_vm.pushSetting, "selfPickup", $$v)
                },
                expression: "pushSetting.selfPickup",
              },
            }),
            _vm._v(" "),
            _vm.pushSetting.selfPickup
              ? _c(
                  "span",
                  { staticClass: "setting-text" },
                  [
                    _vm._v("\n        系统将在预定时间前\n        "),
                    _c("el-input", {
                      staticClass: "time-input",
                      model: {
                        value: _vm.pushSetting.selfPickupTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.pushSetting, "selfPickupTime", $$v)
                        },
                        expression: "pushSetting.selfPickupTime",
                      },
                    }),
                    _vm._v("\n        进行推送\n      "),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "外卖推送" } },
          [
            _c("el-switch", {
              model: {
                value: _vm.pushSetting.delivery,
                callback: function ($$v) {
                  _vm.$set(_vm.pushSetting, "delivery", $$v)
                },
                expression: "pushSetting.delivery",
              },
            }),
            _vm._v(" "),
            _vm.pushSetting.delivery
              ? _c(
                  "span",
                  { staticClass: "setting-text" },
                  [
                    _vm._v("\n        系统将在预定时间前\n        "),
                    _c("el-input", {
                      staticClass: "time-input",
                      model: {
                        value: _vm.pushSetting.deliveryTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.pushSetting, "deliveryTime", $$v)
                        },
                        expression: "pushSetting.deliveryTime",
                      },
                    }),
                    _vm._v("\n        进行推送\n      "),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "繁忙时间段" } },
          [
            _vm._l(_vm.formData.bsyTimeGroup, function (time, index) {
              return _c(
                "div",
                { key: index, staticClass: "busy-time-item" },
                [
                  _c("el-time-picker", {
                    attrs: {
                      placeholder: "请选择时间",
                      format: "HH:mm",
                      "value-format": "HH:mm",
                    },
                    model: {
                      value: time.start,
                      callback: function ($$v) {
                        _vm.$set(time, "start", $$v)
                      },
                      expression: "time.start",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "mx-2" }, [_vm._v("至")]),
                  _vm._v(" "),
                  _c("el-time-picker", {
                    attrs: {
                      placeholder: "请选择时间",
                      format: "HH:mm",
                      "value-format": "HH:mm",
                    },
                    model: {
                      value: time.end,
                      callback: function ($$v) {
                        _vm.$set(time, "end", $$v)
                      },
                      expression: "time.end",
                    },
                  }),
                  _vm._v(" "),
                  index !== 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.removeBusyTime(index)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-delete" })]
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "add-time-btn",
                attrs: { type: "text" },
                on: { click: _vm.addBusyTime },
              },
              [
                _c("i", { staticClass: "el-icon-plus" }),
                _vm._v(" 添加时间段\n      "),
              ]
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c("el-form-item", { attrs: { label: "繁忙加时" } }, [
          _c(
            "div",
            { staticClass: "input-with-unit" },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                model: {
                  value: _vm.formData.bsyPlusTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bsyPlusTime", $$v)
                  },
                  expression: "formData.bsyPlusTime",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit" }, [_vm._v("min")]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tip-text" }, [
            _vm._v("当处于繁忙时间点时加餐时设定"),
          ]),
        ]),
        _vm._v(" "),
        _c("el-form-item", { attrs: { label: "标准运费" } }, [
          _c(
            "div",
            { staticClass: "input-with-unit" },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                model: {
                  value: _vm.formData.shippingFee,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "shippingFee", $$v)
                  },
                  expression: "formData.shippingFee",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit" }, [_vm._v("元")]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("el-form-item", { attrs: { label: "起送金额" } }, [
          _c(
            "div",
            { staticClass: "input-with-unit" },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                model: {
                  value: _vm.formData.minShippingAmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "minShippingAmount", $$v)
                  },
                  expression: "formData.minShippingAmount",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit" }, [_vm._v("元")]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("el-form-item", { attrs: { label: "免邮金额" } }, [
          _c(
            "div",
            { staticClass: "input-with-unit" },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                model: {
                  value: _vm.formData.noShippingAmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "noShippingAmount", $$v)
                  },
                  expression: "formData.noShippingAmount",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit" }, [_vm._v("元")]),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right-section" },
      [
        _c(
          "el-form-item",
          { attrs: { label: "运费活动" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.shippingDto.enabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData.shippingDto, "enabled", $$v)
                  },
                  expression: "formData.shippingDto.enabled",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "运费活动时间" } },
          [
            _c("el-date-picker", {
              attrs: {
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
              },
              model: {
                value: _vm.formData.shippingDto.timeRange,
                callback: function ($$v) {
                  _vm.$set(_vm.formData.shippingDto, "timeRange", $$v)
                },
                expression: "formData.shippingDto.timeRange",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("el-form-item", { attrs: { label: "活动邮费" } }, [
          _c(
            "div",
            { staticClass: "input-with-unit" },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                model: {
                  value: _vm.formData.shippingDto.fee,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData.shippingDto, "fee", $$v)
                  },
                  expression: "formData.shippingDto.fee",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit" }, [_vm._v("元")]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "period-fee-section" },
          [
            _c(
              "el-form-item",
              { attrs: { label: "周期运费活动" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.periodFee.enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.periodFee, "enabled", $$v)
                      },
                      expression: "periodFee.enabled",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.periodFee && _vm.periodFee.enabled
              ? [
                  _c(
                    "el-form-item",
                    { attrs: { label: "有效日期" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.periodFee.dateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.periodFee, "dateRange", $$v)
                          },
                          expression: "periodFee.dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "星期" } }, [
                    _c(
                      "div",
                      { staticClass: "week-select-wrapper" },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.periodFee.weeks,
                              callback: function ($$v) {
                                _vm.$set(_vm.periodFee, "weeks", $$v)
                              },
                              expression: "periodFee.weeks",
                            },
                          },
                          [
                            _c("el-checkbox", { attrs: { label: 1 } }, [
                              _vm._v("周一"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: 2 } }, [
                              _vm._v("周二"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: 3 } }, [
                              _vm._v("周三"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: 4 } }, [
                              _vm._v("周四"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: 5 } }, [
                              _vm._v("周五"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: 6 } }, [
                              _vm._v("周六"),
                            ]),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: 7 } }, [
                              _vm._v("周日"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            staticClass: "select-all-checkbox",
                            attrs: { indeterminate: _vm.isWeekIndeterminate },
                            on: { change: _vm.handleWeekSelectAll },
                            model: {
                              value: _vm.isWeekAllSelected,
                              callback: function ($$v) {
                                _vm.isWeekAllSelected = $$v
                              },
                              expression: "isWeekAllSelected",
                            },
                          },
                          [_vm._v("\n              全选\n            ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动时间" } },
                    [
                      _c("el-time-picker", {
                        attrs: {
                          placeholder: "开始时间",
                          format: "HH:mm",
                          "value-format": "HH:mm",
                        },
                        model: {
                          value: _vm.periodFee.dayStartTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.periodFee, "dayStartTime", $$v)
                          },
                          expression: "periodFee.dayStartTime",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mx-2" }, [_vm._v("至")]),
                      _vm._v(" "),
                      _c("el-time-picker", {
                        attrs: {
                          placeholder: "结束时间",
                          format: "HH:mm",
                          "value-format": "HH:mm",
                        },
                        model: {
                          value: _vm.periodFee.dayEndTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.periodFee, "dayEndTime", $$v)
                          },
                          expression: "periodFee.dayEndTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "活动邮费" } }, [
                    _c(
                      "div",
                      { staticClass: "input-with-unit" },
                      [
                        _c("el-input-number", {
                          attrs: { min: 0 },
                          model: {
                            value: _vm.periodFee.fee,
                            callback: function ($$v) {
                              _vm.$set(_vm.periodFee, "fee", $$v)
                            },
                            expression: "periodFee.fee",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "unit" }, [_vm._v("元")]),
                      ],
                      1
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "餐盒计费" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.packMode,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "packMode", $$v)
                  },
                  expression: "formData.packMode",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("免收")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("固收")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 2 } }, [_vm._v("商品")]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tip-text" }, [
              _vm._v(
                "免收：不收取餐盒费；固收：每单固定收取；商品：根据商品设置收取"
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.formData.packMode === 1
          ? _c("el-form-item", { attrs: { label: "餐盒金额" } }, [
              _c(
                "div",
                { staticClass: "input-with-unit" },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, precision: 2, step: 0.01 },
                    model: {
                      value: _vm.formData.packAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "packAmount", $$v)
                      },
                      expression: "formData.packAmount",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "unit" }, [_vm._v("元")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tip-text" }, [
                _vm._v("设置每单餐盒固定收费金额"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "包装袋计费" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.bagMode,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bagMode", $$v)
                  },
                  expression: "formData.bagMode",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("免收")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("固收")]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tip-text" }, [
              _vm._v("免收：不收取包装袋费用；固收：每单固定收取"),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.formData.bagMode === 1
          ? _c("el-form-item", { attrs: { label: "包装袋金额" } }, [
              _c(
                "div",
                { staticClass: "input-with-unit" },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, precision: 2, step: 0.01 },
                    model: {
                      value: _vm.formData.bagAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "bagAmount", $$v)
                      },
                      expression: "formData.bagAmount",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "unit" }, [_vm._v("元")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tip-text" }, [
                _vm._v("设置每单包装袋固定收费金额"),
              ]),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }